import React from 'react';
import config from 'react-global-configuration';

import { DOMAIN_VNL } from '../../config/constants';
import CartSummary from '../CartSummary';
import './style.scss';

const Hamburger = ({ handleClick, setShowCartPopup, OpenMobileMenu }) => (
  <div className="HamburgerWrap">
    {config.get('CURRENT_DOMAIN') === DOMAIN_VNL && (
      <div className="WebshopLinks">
        <CartSummary setShowCartPopup={setShowCartPopup} />
      </div>
    )}
    <button type="button" className="Hamburger" onClick={handleClick}>
      {
        OpenMobileMenu
          ? (
            <div className="icon icon-cross" />
          )
          :
          (
            <div className="icon icon-hamburger" />
          )
      }
    </button>
  </div>
);

export default Hamburger;
